// Strip any trailing slash — a REACT_APP_API_URL_PREFIX ending in "/" combined with a path
// starting in "/" would otherwise silently produce a double-slash URL (e.g. ".../api//subscribe").
const API_BASE = (process.env.REACT_APP_API_URL_PREFIX || '/api/brandportal-newsletter').replace(/\/+$/, '');

export interface ApiSuccess {
  status: 'ok';
  orderId?: string | number;
  formName?: string;
}

export interface ApiError {
  status: 'error';
  message?: string;
}

export async function postJson<T = ApiSuccess>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error: ApiError = { status: 'error', message: (data as ApiError).message };
    throw error;
  }

  return data as T;
}
